import { Documents } from "./documents";

export class TypeSupport {
  id!: number;
  marketId!: number;
  name!: string;
  icon!: string;
  documents!: Documents[];
  message!: string;
  nbDocument!: number;
}
